module.exports = __webpack_public_path__ + "static/media/black-shoe-box.74d28e8a.png";